import { ximiMobileGetFlat } from './ximiMobileClient';

// Endpoint Ozmo : liste enrichie des relations de l'appelant (bénéficiaires d'un aidant/agent,
// aidants d'un bénéficiaire), signée RS256. Endpoint « flat » : le tenant est résolu côté
// serveur via le claim `xelya.provider` du token SSO.
const STIMULIN_BENEFICIARIES = 'stimulin/beneficiaries';

export type XimiBeneficiariesResult =
    | { ok: true; token: string }
    | { ok: false; status?: number; code?: string; reason: string };

/** Récupère le JWT listant les relations. Opaque ici : seul StimulinAPI le vérifie. */
export async function fetchXimiBeneficiaries(): Promise<XimiBeneficiariesResult> {
    try {
        const { status, data } = await ximiMobileGetFlat<{ token?: string; code?: string }>(
            STIMULIN_BENEFICIARIES
        );
        if (status < 200 || status >= 300) {
            return { ok: false, status, code: data?.code, reason: `HTTP ${status}` };
        }
        return data?.token
            ? { ok: true, token: data.token }
            : { ok: false, status, reason: 'No token in response' };
    } catch (error) {
        return { ok: false, reason: error instanceof Error ? error.message : 'Network error' };
    }
}
